export const RULE_MESSAGE: Record<string, string> = {
  required: 'Обязательно для заполнения',
}
